<template>
  <div class="row mt-3" v-if="show">
    <div class="col-lg-12 text-center">
      <button
        type="button"
        class="btn"
        :class="classes"
        v-on:click="copyLink"
        style="cursor: pointer;"
      >{{ T.copyLink[lang] }}</button>
      <br>
      <input id="url" type="text" class="hidden">
    </div>
  </div>
</template>

<script>
import { DREAMJOBS } from '../js/main';
import { T } from '../js/translations';

export default {
  data: function() {
    return {
      copied: false,
      show: !DREAMJOBS,
      T: T
    };
  },
  props: {
    taxes: {
      type: Object,
      required: true
    },
    lang: String
  },
  computed: {
    classes: function() {
      return {
        "btn-outline-info": !this.copied,
        "btn-info": this.copied
      };
    }
  },
  watch: {
    taxes: function(newTaxes) {
      this.newUrl();
    }
  },
  methods: {
    copyLink: function(e) {
      var url = window.location.href;
      var input = document.getElementById("url");
      input.value = url;
      input.classList.remove("hidden");
      input.select();
      try {
        var success = document.execCommand("copy");
        if (success) {
          this.copied = true;
        } else {
          alert(this.T.clipboardError[this.lang]);
        }
      } catch (e) {
        alert(this.T.clipboardError[this.lang]);
      }
      input.classList.add("hidden");
    },
    newUrl: function() {
      this.copied = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// Link.vue?dbdb78d6